<ion-header>
  <ion-toolbar>
    <ion-title>QR Info</ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-text-capitalize" (click)="onPrintClick()" *ngIf="printAvailability">Print</ion-button>
      <ion-button class="ion-text-capitalize" (click)="onCloseClick()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="d-flex flex-column qr-code-container" id="qr-code-container" #qrTemplate>
    <div class="pt-3 ion-text-center header">
      <!-- <ion-icon name="fast-food-outline"></ion-icon> -->
      <img src="assets/fast-food-outline.png" alt="">
      <span class="title">E-Menu</span>
    </div>
    <div class="ion-text-center label">
      Scan the QR code
    </div>
    <div class="ion-text-center flex-grow-1">
      <ng-container *ngIf="qrInfo">
        <div class="qr-code" [style.backgroundImage]="'url(data:image/png;base64,' + qrInfo.qrCodeImage + ')'"></div>
        <ion-label class="ion-text-center identity">
          <span [innerText]="qrInfo?.qrCodeInfo?.rc"></span>&nbsp;/
          <span [innerText]="qrInfo?.qrCodeInfo?.rbc"></span>&nbsp;/
          <span [innerText]="qrInfo?.qrCodeInfo?.rbtc"></span>
        </ion-label>
      </ng-container>
    </div>
    <div class="ion-text-center footer">
      <app-signature></app-signature>
    </div>
  </div>
</ion-content>